.componentWebsiteContentSchedule {

  .module {
    min-width: 320px;
    height: 700px;
  }
}